<template>
  <LayoutContent>
    <SectionTitle :label="$t('label.partnerStatus')" />
    <v-container>
      <div class="d-flex flex-column align-center mb-4" v-if="currentUser && currentAgent">
        <AgentIcon :level="currentAgent.ranking.replace('Style', '').trim().toUpperCase()" large />
        <h3 class="text-center secondary--text mt-2">{{ agentRankName }}</h3>
      </div>
      <div
        class="elevation-2 rounded-lg white d-flex flex-column align-center text-center py-4 mb-10"
        :class="$vuetify.breakpoint.smAndUp ? 'px-16' : 'px-2'"
        v-if="currentAgent && currentAgent.ranking !== 'Platinum Style'"
      >
        <p class="primary--text text--lighten-1 font-weight-bold" v-if="currentAgent.next_ranking">{{ $t('message.youAreOnYourWayToBecoming') }} {{ currentAgent.next_ranking }}!</p>
        <p class="secondary--text text--lighten-1" v-if="currentAgent.next_ranking">{{ $t('message.inviteMoreFriendsToUnlockTheNextLevel') }}</p>
        <v-divider class="my-4 w-100" v-if="currentAgent.next_ranking" />
        <div class="d-flex">
          <div class="next-invite-goal mr-8 text-body-2">
            <span>
              <v-icon class="transparent primary--text text--lighten-1">mdi-account-outline</v-icon>
              {{ $t('label.toOwn') }}
            </span>
            <span>
              <AgentIcon small :level="currentAgent.ranking.replace('Style', '').trim().toUpperCase()" />
              {{ currentAgent.ranking }} x {{ currentAgent.direct_needed }}
            </span>
          </div>
        </div>
      </div>
      <v-tabs class="agent-tab-wrapper mb-4" slider-color="primary darken-1" v-model="currentTab" centered @change="onTabChange">
        <v-tab v-for="tab in tabs" :key="tab.key" class="text-capitalize text-subtitle-1 text-center font-weight-bold" active-class="primary--text text--darken-1">
          {{ $t(`label.${tab.key}`) }}
        </v-tab>
        <v-tabs-items class="white rounded-lg elevation-2" v-model="currentTab">
          <v-tab-item>
            <CashBack />
          </v-tab-item>
          <v-tab-item>
            <MyTeam />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-container>
  </LayoutContent>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue'
import LayoutContent from '@/views/layouts/LayoutContent.vue'
import AgentIcon from '@/components/AgentIcon.vue'
import MyTeam from '@/components/agent/MyTeam.vue'
import CashBack from '@/components/agent/CashBack.vue'
import { localeHelper } from '@/utils'
import { mapState } from 'vuex'

export default {
  name: 'Dashboard',
  components: {
    SectionTitle,
    LayoutContent,
    AgentIcon,
    MyTeam,
    CashBack
  },
  data: () => ({
    tabs: [
      { key: 'cashBack', title: localeHelper.getMessage('label.cashBack') },
      { key: 'myTeam', title: localeHelper.getMessage('label.myTeam') }
    ],
    currentTab: null
  }),
  computed: {
    ...mapState('auth', ['currentUser']),
    ...mapState('agent', ['currentAgent']),
    agentRankName() {
      let name = ''
      let rank = this.currentUser.ranking.replace('Style', '').trim().toLowerCase()
      switch (rank) {
        case 'silver':
          name = localeHelper.getMessage('label.silver')
          break
        case 'gold':
          name = localeHelper.getMessage('label.gold')
          break
        case 'platinum':
          name = localeHelper.getMessage('label.platinum')
          break
        case 'executive':
          name = localeHelper.getMessage('label.executive')
          break
      }
      return name
    }
  },
  created() {
    this.currentTab = this.tabs.findIndex((f) => f.key === this.$route.query.tab)
  },
  methods: {
    onTabChange(tabIndex) {
      this.$router.replace({ name: this.$constants.ROUTE_NAME.AGENT_DASHBOARD, query: { tab: this.tabs[tabIndex].key } })
    }
  }
}
</script>

<style lang="scss">
.next-invite-goal > span:first-of-type {
  margin-right: 1rem;
}

.agent-tab-wrapper > .v-slide-group {
  background-color: transparent !important;
  margin-bottom: 2rem;
}

.agent-tab-wrapper > .v-tabs-items {
  background: white;
}

/* for CashOut and MyTeam */
$filter-dropdown-font-size: 0.75rem;

.filter-dropdown {
  display: inline-block;
  font-size: $filter-dropdown-font-size !important;

  .v-select__slot {
    width: auto;
    > .v-select__selections {
      .v-select__selection {
        font-size: $filter-dropdown-font-size !important;
        overflow: unset;
      }
    }
  }

  .v-input__append-inner {
    margin-top: auto !important;
    margin-bottom: auto !important;

    .v-icon.v-icon.v-icon--link {
      background-color: #fff;
      font-size: 1rem;
    }
  }

  &.v-input--is-label-active .v-select__selections input {
    display: none;
  }
}

.filter-dropdown--item {
  font-size: $filter-dropdown-font-size !important;
}
</style>
